import { NgModule,NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePagesRoutingModule } from './home-pages-routing.module';
import { HomePageComponent } from './home-page.component';
import { TranslateModule } from '@ngx-translate/core';
import { HomeCardComponent } from '../home-card/home-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from 'src/app/material.module';
import { AdminComponent } from '../dashboard/admin/admin.component';
import { DashboardOperatorComponent } from '../dashboard/dashboard-operator/dashboard-operator.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AdministrativeReportComponent } from 'src/app/forms/administrative-report/administrative-report.component';
import { ChartsModule } from 'ng2-charts-x';
import { UserConfigComponent } from 'src/app/forms/user-config/user-config.component';
import { ShortcutComponent } from 'src/app/forms/shortcut/shortcut.component';
import { UploadPicturesModule } from 'src/app/shared/upload-pictures/upload-pictures.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';


@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    HomePagesRoutingModule,
    SharedModule,
    ChartsModule,
    NgxChartsModule,
    UploadPicturesModule
  ],
  declarations: [
    HomePageComponent,
    HomeCardComponent,
    UserConfigComponent,
    AdminComponent,
    DashboardOperatorComponent,
    ShortcutComponent
  ],
  exports: [
    TranslateModule
  ]
})

export class HomePagesModule {

}
